'use client'

import { type AxiosError, type AxiosResponse } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import { type LoginOtpRequestRequestV3 } from '@redteclab/api/clients/composition-service-loyalty'

import { buildHomeOneApiAxiosInstance } from '../../../api'
import {
  type PublicGlobalConfig,
  useGlobalConfigContext,
} from '../../../global-config'
import { urlResolverGetOneTimePasswordInitiateApiEndpoint } from '../../../url-handling'

const postOneTimePasswordRequestData =
  (globalConfig: PublicGlobalConfig) =>
  async (
    swrKey: string,
    data: { arg: LoginOtpRequestRequestV3 },
  ): Promise<AxiosResponse> => {
    return buildHomeOneApiAxiosInstance(globalConfig).post(
      urlResolverGetOneTimePasswordInitiateApiEndpoint(globalConfig),
      data.arg,
      {
        headers: {
          ...(process.env.NEXT_PUBLIC_SKIP_FRIENDLY_CAPTCHA === 'true' && {
            'skip-friendly-captcha-verification': 'true',
          }),
        },
      },
    )
  }

const getOneTimePasswordApiRequestMutationKey = (): string => {
  return 'useOneTimePasswordApiRequestMutation'
}

export const useOneTimePasswordApiRequestMutation = ({
  onError,
  onSuccess,
}: {
  onError: (err: AxiosError) => void
  onSuccess?: (afterLoginSideeffectsPromise: Promise<unknown>) => void
}): SWRMutationResponse<
  Promise<unknown>,
  AxiosError,
  string,
  LoginOtpRequestRequestV3
> => {
  const globalConfig = useGlobalConfigContext()

  return useSWRMutation(
    getOneTimePasswordApiRequestMutationKey(),
    postOneTimePasswordRequestData(globalConfig),
    {
      onError,
      onSuccess,
    },
  )
}
